export const INITIAL_MOBILE_MODE = false;
//# sourceMappingURL=initialMobileMode.js.map